<template>
  <div
    v-if="pagination"
    class="
      grid
      sm-col
      grid-cols-2
      md:grid-cols-3
      lg:grid-cols-4
      xl:grid-cols-5
      gap-5
    "
  >
    <div v-for="(specimen, index) in pagination.data" :key="index">
      <!-- 連結到各個標本資訊頁 -->
      <router-link target="_blank" :to="`/specimen/${specimen.id}`">
        <div
          class="
            border border-gray-100
            rounded-md
            bg-gray-50
            hover:shadow-lg hover:text-black
          "
        >
          <!-- 縮圖 -->
          <div v-if="specimen.state_of_check === 1" class="h-64">
            <img :src="specimen.pic_150_url" class="p-5 mx-auto thumbnail" alt="標本縮圖"/>
          </div>
          <div v-else class="h-64 flex items-center justify-center">
            <img src="@/assets/alternative_image.jpg" alt="標本預設縮圖" class="w-28 h-28"/>
          </div>

          <!-- 最新鑑定學名 -->
          <div class="p-4 bg-gray-100 h-20">
            <p v-html="specimen.revised_taxon" class="thumbnail-over-line"/>
            </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pagination"],
};
</script>

<style scoped>
.thumbnail-over-line {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

@media (max-width: 499.98px) {
  .sm-col{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

.link-color {
  color: #64859D;
}

.link-color:hover {
  color: #64859D;
  font-weight: 700;
}

.thumbnail {
  width: 175px;
  height: 250px;
}
</style>
